// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7092bb33","453":"1afb0cda","455":"e56c6253","977":"f8795bc7"}[chunkId] + ".chunk.js";
};